import React from "react";
import { LoginPart } from "../../../../public/loginPage/login";
import CustomDialog from "../../../../../components/custom/dialog";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../app/redux/hooks";
import CustomButton from "../../../../../components/custom/button";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { setStepperActiveMenu } from "../../../../../../app/slices/checkoutSlice/CheckoutSlice";

export const AccountSection = () => {
  const dispatch = useAppDispatch();
  const [modalType, setModalType] = React.useState("");
  const { profileData, isValidUser }: any = useAppSelector(
    (state) => state.ProfileState
  );

  const onOpenModal = (type: string) => {
    setModalType(type);
  };

  const onCloseModal = () => {
    setModalType("");
  };

  const onNextClick = (active: any) => {
    dispatch(setStepperActiveMenu(active));
  };
  React.useEffect(() => {
    if (isValidUser) {
      onNextClick("address");
    }
  }, [isValidUser]);

  return (
    <>
      {!isValidUser ? (
        <div>
          <div>
            <p className="mb-3">
              To place your order now, login to your existing account or sign up
            </p>
            <button onClick={() => onOpenModal("login")} className="btn-prime">
              LOG IN
            </button>
          </div>

          <CustomDialog
            component={
              <LoginPart onClose={onCloseModal} isFromAccount={true} />
            }
            title="Login"
            openDialog={modalType === "login"}
            handleCloseDialog={onCloseModal}
            modalPlace="center"
          />
        </div>
      ) : null}
    </>
  );
};
